import { $axios, apiList } from '@/api'

export default {
    actions: {
        triggerUrlView(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.url.viewURl.method,
                    params: {
                        wsfunction: apiList.url.viewURl.moodle_method,
                        urlid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getUrlsByCourse(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.url.getUrls.method,
                    params: {
                        wsfunction: apiList.url.getUrls.moodle_method,
                        courseids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
